import { useParams } from 'react-router-dom';

import { notificationDataService } from 'services/notification.service';

import { useFetch } from 'hooks';

import { Product } from './RelatedProducts.types';

export const useRelatedProducts = () => {
  const { id } = useParams<{ id: string }>();

  const { data: notificationData, isLoading } = useFetch(
    id ? () => notificationDataService.getById(id) : undefined,
    [id]
  );

  const products: Product[] = notificationData?.products ?? [];

  return { products, isLoading };
};
